// extracted by mini-css-extract-plugin
module.exports = {"searchPage":"Search_searchPage__m7RrG","pageSidebar":"Search_pageSidebar__3KKjI"};